import { Proxy } from "./src/proxy"

export const DEFAULT_PROXY = new Proxy()